<template>
  <div class="new-request-page">
    <div class="page-top-bar user-page-banner">
      <div>
        <h2 class="page-title">{{ $t('sendReport.modalTitle') }}</h2>
      </div>
      <button v-if="isAdmin" type="button" class="page-close-btn admin-close-btn" @click="closePage">
        <CIcon name="cil-x" class="mr-1" /> {{ $t('common.close') }}
      </button>
      <button v-else type="button" class="page-close-btn keyboard-action" :aria-label="$t('common.close')" @click="closePage">
        ✕
      </button>
    </div>

    <SendReport displayMode="page" :showHeader="false" :adminButtonStandard="isAdmin" @ticket-created="onTicketCreated" @close="closePage" />
  </div>
</template>

<script>
import SendReport from "@/components/user/SendReport.vue";

export default {
  name: 'NewRequest',
  components: {
    SendReport,
  },
  data: () => ({ addedUserThemeClass: false }),
  computed: {
    isAdmin() {
      if (this.$route?.meta?.roles && Array.isArray(this.$route.meta.roles)) {
        if (this.$route.meta.roles.includes('admin')) return true;
      }
      const authUser = this.$store?.state?.auth?.user || this.$store?.getters?.['auth/profile'];
      if (authUser?.role === 'admin') return true;
      return Boolean(this.$route?.path && this.$route.path.startsWith('/admin/'));
    },
  },
  mounted() {
    if (!document.body.classList.contains('user-unified-rounded-ui')) {
      document.body.classList.add('user-unified-rounded-ui');
      this.addedUserThemeClass = true;
    }
  },
  beforeDestroy() {
    if (this.addedUserThemeClass) document.body.classList.remove('user-unified-rounded-ui');
  },
  methods: {
    returnPath() {
      if (this.$route.path.startsWith('/admin/')) return '/admin/reportlist';
      if (this.$route.path.startsWith('/supervisor/')) return '/supervisor/reportlist';
      if (this.$route.path.startsWith('/technician/')) return '/technician/maintechnician';
      if (this.$route.path.startsWith('/student-affairs/')) return '/student-affairs/my-reports';
      return '/user/mainuser';
    },
    navigateBack() {
      const target = this.returnPath();
      if (this.$route.path !== target) {
        this.$router.push(target);
      }
    },
    onTicketCreated() {
      this.navigateBack();
    },
    closePage() {
      this.navigateBack();
    },
  },
};
</script>

<style scoped>
.new-request-page {
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 0 18px 28px;
  background: #f5f6f8;
}

@media (min-width: 769px) {
  .new-request-page {
    padding-right: 0;
    padding-left: 0;
  }
}

.page-top-bar {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 14px;
}

.page-title {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  color: #1f1f1f;
}

.page-subtitle {
  margin: 8px 0 0;
  color: #6b7280;
  max-width: 640px;
}

.page-close-btn {
  border: none;
  background: transparent;
  color: #6b7280;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  padding: 8px;
}

.page-close-btn.admin-close-btn {
  font-size: 0.88rem;
  font-weight: 600;
  border: 1px solid #d8dbe0;
  border-radius: 8px;
  background-color: #ffffff;
  color: #4f5d73;
  padding: 6px 12px;
  display: inline-flex;
  align-items: center;
  transition: all 0.2s ease;
}
.page-close-btn.admin-close-btn:hover {
  background-color: #f8f9fa;
  border-color: #c4c9d0;
  color: #2c384a;
}

@media (min-width: 769px) and (max-width: 1100px) {
  .new-request-page {
    padding: 0 12px 24px;
  }

  .page-top-bar {
    margin-bottom: 12px;
  }

  .page-title {
    font-size: 24px;
  }
}

@media (max-width: 768px) {
  .new-request-page {
    padding: 0 0 24px;
    background: #f5f6f8;
  }
  .page-top-bar {
    align-items: center;
    margin: 0 0 22px;
    padding: 17px 16px 14px;
    border-bottom: 1px solid #e2e8f0;
  }
  .page-subtitle {
    display: none;
  }
  .page-title {
    color: #1e40af;
    font-size: 1.25rem;
    font-weight: 800;
  }
  .page-close-btn {
    margin-left: auto;
    color: #1e40af;
    font-size: 20px;
  }
}

/* Keep this shared page visually identical in every role container. */
.page-top-bar {
  width: 100%;
  min-height: 112px;
  align-items: center;
  margin-top: 0;
  padding: 22px 28px;
  border: 0;
  border-radius: 0;
  color: #fff;
  background: #1e40af;
  box-shadow: none;
}

.page-top-bar .page-title,
.page-top-bar .page-close-btn {
  color: #fff;
}

@media (max-width: 768px) {
  .page-top-bar {
    min-height: 88px;
    margin-bottom: 16px;
    padding: 14px 16px;
  }
}
</style>
